// eslint-disable-next-line vue-component-file-name-match/match-component-import-name
import KaListboxBase from './KaListbox.vue';
import KaListboxOption from './KaListboxOption.vue';
import KaListboxPortal from './KaListboxPortal.vue';

export type {
  DetermineMultiOrSingleValue,
  KaListBoxEmit,
  KaListboxOptionProps,
  KaListboxOptionValueType,
  KaListBoxProps,
} from './types';

Object.assign(KaListboxBase, {
  Option: KaListboxOption,
  Portal: KaListboxPortal,
});

export const KaListbox = KaListboxBase as typeof KaListboxBase & {
  readonly Option: typeof KaListboxOption;
  readonly Portal: typeof KaListboxPortal;
};

export { KaListboxOption };
